<section id="section-report" class="container-fluid mt-1">
  <div class="row" *ngIf="inventoryTransferModel">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{ inventoryTransferModel.inventoryTransferId }}" class="head col-12 col-lg-12">
                  <!--Nombre Compañía -->
                  <p id="nombre-compania-{{ inventoryTransferModel.inventoryTransferId }}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{ inventoryTransferModel.companyName }}
                  </p>

                  <!-- Inventario  -->
                  <label id="t-inventario-{{inventoryTransferModel.inventoryTransferId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-inventario' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="inventario-{{inventoryTransferModel.inventoryTransferId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{inventoryTransferModel.inventoryName}}</p>

                  <!--Nombre Traslado -->
                  <p id="nombre-traslado-{{ inventoryTransferModel.inventoryTransferId }}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{ 'TRASLADO Nro.'+ inventoryTransferModel.consecutive }}
                  </p>

                  <!--Sucursal Envío-->
                  <label id="t-sucursal-envio-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-sucursal-envio'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="sucursal-envio-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{inventoryTransferModel.branchOutputName}}</p>

                  <!--Bodega Envío-->
                  <label id="t-bodega-envio-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-bodega-envio'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="bodega-envio-{{inventoryTransferModel.inventoryTransferId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryTransferModel.storeOutputName}}</p>

                  <!--Sucursal Recepción-->
                  <label id="t-sucursal-recepcion-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-sucursal-recepcion'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="sucursal-recepcion-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{inventoryTransferModel.branchEntryName}}</p>

                  <!--Bodega Recepción-->
                  <label id="t-bodega-recepcion-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-bodega-recepcion'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="bodega-recepcion-{{inventoryTransferModel.inventoryTransferId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{inventoryTransferModel.storeEntryName}}</p>

                  <!-- Fecha Envío -->
                  <label id="t-fecha-envio-{{inventoryTransferModel.inventoryTransferId }}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                    "t-fecha-envio" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="fecha-envio-{{ inventoryTransferModel.inventoryTransferId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ inventoryTransferModel.dateOutput | date : "dd/MM/yyyy" }}
                  </p>

                  <!-- Fecha Recepción -->
                  <label id="t-fecha-recepcion-{{ inventoryTransferModel.inventoryTransferId }}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                    "t-fecha-recepcion" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="fecha-recepcion-{{ inventoryTransferModel.inventoryTransferId }}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{ inventoryTransferModel.dateEntry | date : "dd/MM/yyyy" }}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-inventory-transfer-{{ inventoryTransferModel.inventoryTransferId }}"
                  [columns]="columns" [data]="inventoryTransferModel.inventoryTransferDetails" [idMap]="idMap"
                  [documentId]="inventoryTransferModel.inventoryTransferId" [footerVisible]="true"
                  [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{ inventoryTransferModel.inventoryTransferId }}" class="foot mt-3 container-observations">
                <label id="t-observacion-{{ inventoryTransferModel.inventoryTransferId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="inventoryTransferModel.observation">{{
                  "t-observacion" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="observacion-{{ inventoryTransferModel.inventoryTransferId }}" class="lh-sm observation"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="inventoryTransferModel.observation">
                  {{ inventoryTransferModel.observation }}
                </p>

                <!-- Transporte -->
                <label id="t-valor-transporte-{{ inventoryTransferModel.inventoryTransferId }}" for=""
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-valor-transporte" | formatLabelPipe : elementsLabel }}</label>
                <p id="valor-transporte-{{ inventoryTransferModel.inventoryTransferId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{ inventoryTransferModel.transportValue | currency }}
                </p>

                <!-- Transportador-->
                <p id="transportador-{{ inventoryTransferModel.inventoryTransferId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{ inventoryTransferModel.transporterName }}
                </p>
                <p id="linea-firma-transportador-{{inventoryTransferModel.inventoryTransferId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-firma-transportador-{{ inventoryTransferModel.inventoryTransferId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{ "t-firma-transportador" |
                  formatLabelPipe : elementsLabel }}</label>

                <!-- Firma Entrega-->
                <p id="linea-firma-entrega-{{ inventoryTransferModel.inventoryTransferId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-entrega-{{ inventoryTransferModel.inventoryTransferId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-linea-entrega" | formatLabelPipe : elementsLabel
                  }}</label>

                <!-- Firma Recibe-->
                <p id="linea-firma-recibe-{{ inventoryTransferModel.inventoryTransferId }}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-recibe-{{ inventoryTransferModel.inventoryTransferId }}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                  "t-linea-recibe" | formatLabelPipe : elementsLabel
                  }}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4">{{ version }}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha:
                </label>
                <p id="fecha-impresion" class="pe-4">
                  {{ dateNow | date : "dd/MM/yyyy" }}
                </p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4">
                  {{ dateNow | date : "hh:mm:ss a" }}
                </p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario:
                </label>
                <p id="usuario-impresion" class="pe-4">
                  {{ userAuthenticated }}
                </p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">
                    Documento generado con el Software Cervino Web de Altos
                    Software SAS. Nit.811.022.121-1. www.altos-soft.com
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>